import { get } from 'app/utils/axios/kheti'
import { CropsWithCategory } from "../models/crop";

const fetchAllCrops = async () => {
  try {
    const url = "/crop/v2/all";
    const response = await get<CropsWithCategory[]>(url);
    return response;
  } catch (e) {
    return null;
  }
};

export default fetchAllCrops;
